import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';

import { msalInstance } from 'src/auth/msalInstance';
import { logger } from 'src/utils';

export const getAuthOptions = async () => {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();

  const accessTokenRequest = {
    scopes: ['User.Read', 'profile', 'openid', 'email', 'offline_access'],
    account: accounts[0] as AccountInfo,

    // NOTE: MSAL will sometimes return the same ID token even if it's expired, due
    // to changes in Azure AD. This is a horrid workaround, but it works for now.
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4206
    forceRefresh: true,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: ` ${response.idToken}`,
    };

    const assumedUserId = sessionStorage.getItem('assumedUserId');
    if (assumedUserId) {
      headers['X-Assume-User-Id'] = assumedUserId;
    }

    return { headers };
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // User is redirected to the authorization page. They'll be returned back to the app
      // after they've authenticated again.
      msalInstance.acquireTokenRedirect(accessTokenRequest);
      return;
    }

    logger.error('Error acquiring token silently', { err: error });
  }
};
